import React from "react";
import { useSelector } from "react-redux";
import classes from "./CounterItem.module.css";


const CounterItem = ({ count, icon, label }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <div className={classes.CounterItem}>
            <div className={classes.CounterValueRow}>
                <span className={classes.IconWrap}>
                    {icon && <img src={icon} alt="" className={classes.IconImage} />}
                </span>
                <span className={classes.Count}>{count}</span>
            </div>
            <span className={classes.Label}>{texts[label]}</span>
        </div>
    );
}

export default CounterItem;
